document.addEventListener("DOMContentLoaded", initMegaMenuImagePreview);
document.addEventListener("DOMContentLoaded", clearLegacyScrollLocks);
document.addEventListener("DOMContentLoaded", initCartDrawerScrollLock);
document.addEventListener("DOMContentLoaded", initProductMediaModalScrollLock);

function initMegaMenuImagePreview() {
  const links = document.querySelectorAll(".mega-menu__link");
  const previews = document.querySelectorAll(".megaMenuImage");
  const defaultImages = [];

  previews.forEach((img, i) => {
    defaultImages[i] = img.getAttribute("src");
  });

  links.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      let img = link.getAttribute("data-image") || link.getAttribute("url");
      if (!img) return;
      if (img.startsWith("//")) img = "https:" + img;

      previews.forEach((preview) => {
        preview.setAttribute("src", img);
      });
    });
  });

  const menu = document.querySelector(".mega-menu__list");
  if (menu) {
    menu.addEventListener("mouseleave", () => {
      previews.forEach((preview, i) => {
        preview.setAttribute("src", defaultImages[i]);
      });
    });
  }
}

function isDocumentOverlayOpen() {
  return Boolean(
    document.querySelector("cart-drawer.active, cart-drawer[open], product-modal[open]") ||
      document.body.classList.contains("glow-video-popup-open") ||
      document.documentElement.classList.contains("glow-video-popup-open")
  );
}

function clearInlineScrollStyles(element) {
  element.style.overflow = "";
  element.style.position = "";
  element.style.top = "";
  element.style.left = "";
  element.style.right = "";
  element.style.width = "";
  element.style.height = "";
}

function clearLegacyScrollLocks() {
  ["lenis", "lenis-smooth", "lenis-scrolling", "lenis-stopped", "cart-drawer-lenis-paused"].forEach(
    function (className) {
      document.documentElement.classList.remove(className);
      document.body.classList.remove(className);
    }
  );

  window.lenis = null;
  window.__lenis = null;
  delete document.documentElement.__lenis;
  delete document.documentElement._lenis;

  if (isDocumentOverlayOpen()) return;

  clearInlineScrollStyles(document.documentElement);
  clearInlineScrollStyles(document.body);
  document.body.classList.remove("overflow-hidden");
}

function getDocumentScrollY() {
  return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
}

function restoreDocumentScrollY(scrollY) {
  window.scrollTo(0, scrollY);
}

function createBackgroundScrollLock(isEventInsideOverlay) {
  let isLocked = false;
  let lockedScrollY = 0;

  const preventBackgroundScroll = (event) => {
    if (!isLocked || isEventInsideOverlay(event.target)) return;
    event.preventDefault();
  };

  const lock = () => {
    if (isLocked) return;

    isLocked = true;
    lockedScrollY = getDocumentScrollY();

    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = "-" + lockedScrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.documentElement.style.overflow = "hidden";

    document.addEventListener("wheel", preventBackgroundScroll, {
      passive: false,
      capture: true,
    });
    document.addEventListener("touchmove", preventBackgroundScroll, {
      passive: false,
      capture: true,
    });
  };

  const unlock = () => {
    if (!isLocked) return;
    isLocked = false;

    document.removeEventListener("wheel", preventBackgroundScroll, {
      capture: true,
    });
    document.removeEventListener("touchmove", preventBackgroundScroll, {
      capture: true,
    });

    clearInlineScrollStyles(document.documentElement);
    clearInlineScrollStyles(document.body);

    restoreDocumentScrollY(lockedScrollY);
  };

  return {
    get locked() {
      return isLocked;
    },
    lock,
    unlock,
  };
}

function initCartDrawerScrollLock() {
  const BODY_OPEN_CLASS = "cart-drawer-open";

  let drawer = null;
  let drawerObserver = null;
  let isBound = false;

  const getDrawer = () => document.querySelector("cart-drawer");

  const isDrawerOpen = () => {
    const current = getDrawer();
    if (!current) return false;

    return current.classList.contains("active") || current.hasAttribute("open");
  };

  const isEventInsideDrawer = (target) => {
    const current = getDrawer();
    return target instanceof Element && current && current.contains(target);
  };

  const scrollLock = createBackgroundScrollLock(isEventInsideDrawer);

  const syncLockState = () => {
    if (isDrawerOpen()) {
      document.body.classList.add(BODY_OPEN_CLASS);
      scrollLock.lock();
      return;
    }

    document.body.classList.remove(BODY_OPEN_CLASS);
    scrollLock.unlock();
  };

  const wrapDrawerMethod = (methodName) => {
    if (!drawer || typeof drawer[methodName] !== "function") return;
    if (drawer["__glamyeScroll" + methodName]) return;

    const original = drawer[methodName].bind(drawer);
    drawer["__glamyeScroll" + methodName] = true;
    drawer[methodName] = function (...args) {
      const result = original(...args);
      syncLockState();
      return result;
    };
  };

  const bindDrawer = () => {
    const current = getDrawer();
    if (!current || current === drawer) return;

    if (drawerObserver) drawerObserver.disconnect();

    drawer = current;
    drawerObserver = new MutationObserver(syncLockState);
    drawerObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ["class", "open"],
    });

    wrapDrawerMethod("open");
    wrapDrawerMethod("close");
    syncLockState();
  };

  const start = () => {
    if (isBound) {
      bindDrawer();
      return;
    }

    isBound = true;

    new MutationObserver((mutations) => {
      const replaced = mutations.some((mutation) => {
        if (mutation.type !== "childList") return false;
        return [...mutation.addedNodes, ...mutation.removedNodes].some(
          (node) => node.nodeType === 1 && node.matches && node.matches("cart-drawer")
        );
      });

      if (!replaced) return;
      bindDrawer();
    }).observe(document.body, {
      childList: true,
      subtree: true,
    });

    bindDrawer();
  };

  if (window.customElements && typeof window.customElements.whenDefined === "function") {
    window.customElements.whenDefined("cart-drawer").then(start);
  }

  start();
}

function initProductMediaModalScrollLock() {
  const CUSTOM_ELEMENT_TAG = "product-modal";

  let modal = null;
  let modalObserver = null;

  const getModal = () => document.querySelector(CUSTOM_ELEMENT_TAG);

  const isModalOpen = () => {
    const current = getModal();
    return Boolean(current && current.hasAttribute("open"));
  };

  const isEventInsideModal = (target) => {
    const current = getModal();
    return current instanceof Element && target instanceof Element && current.contains(target);
  };

  const scrollLock = createBackgroundScrollLock(isEventInsideModal);

  const syncLockState = () => {
    if (isModalOpen()) {
      scrollLock.lock();
      return;
    }

    scrollLock.unlock();
  };

  const wrapModalMethod = (methodName) => {
    if (!modal || typeof modal[methodName] !== "function") return;
    if (modal["__glamyeScroll_" + methodName]) return;

    const original = modal[methodName].bind(modal);
    modal["__glamyeScroll_" + methodName] = true;
    modal[methodName] = function (...args) {
      const result = original(...args);
      requestAnimationFrame(syncLockState);
      return result;
    };
  };

  const bindModal = () => {
    const current = getModal();
    if (!current) return;

    if (current !== modal) {
      if (modalObserver) modalObserver.disconnect();
      modal = current;

      modalObserver = new MutationObserver(syncLockState);
      modalObserver.observe(modal, {
        attributes: true,
        attributeFilter: ["open", "class", "aria-hidden"],
      });
    }

    wrapModalMethod("show");
    wrapModalMethod("hide");
    wrapModalMethod("open");
    wrapModalMethod("close");
    syncLockState();
  };

  new MutationObserver((mutations) => {
    const affected = mutations.some((mutation) => {
      if (mutation.type !== "childList") return false;
      return [...mutation.addedNodes, ...mutation.removedNodes].some(
        (node) => node.nodeType === 1 && node.matches && node.matches(CUSTOM_ELEMENT_TAG)
      );
    });
    if (affected) bindModal();
  }).observe(document.body, { childList: true, subtree: true });

  bindModal();
}


 document.addEventListener('DOMContentLoaded', function () {
    var containers = document.querySelectorAll('media-gallery.product__column-sticky');

    containers.forEach(function (container) {
      var indicator = container.querySelector('.scroll-indicator');
      if (!indicator) return;

      function checkScroll() {
        var isScrollable = container.scrollHeight > container.clientHeight + 5;
        var atBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 5;

        if (!isScrollable || atBottom) {
          indicator.classList.add('is-hidden');
        } else {
          indicator.classList.remove('is-hidden');
        }
      }

      indicator.addEventListener('click', function () {
        container.scrollBy({
          top: container.clientHeight,
          behavior: 'smooth'
        });
      });

      container.addEventListener('scroll', checkScroll);
      window.addEventListener('resize', checkScroll);

      setTimeout(checkScroll, 300);
      checkScroll();
    });
  });
